import { APIResponseErrorCodes, AppEnvs, AppStorageKeys } from "./Constants";
import { store } from "../Store/Store";
import LocalStorage from "./LocalStorage";
import SessionStorage from "./SessionStorage";
import { logout } from "../Store/authStore";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

/** Use this to get user-roel configuration */
export const getUserRoleConfigFromStore = () => {
  const state = store.getState();
  return state.auth.userRoleConfig;
};
export const getUserRoleConfigFromStorage = () => {
  const config = SessionStorage.get(AppStorageKeys.userRoles);
  SessionStorage.remove(AppStorageKeys.userRoles);
  return config;
};

/** Use this to get current user information */
export const getCurrentUserFromStore = () => {
  const state = store.getState();
  return state.auth.currentUser;
};
/** Only tobe used for initial store setup */
export const getCurrentUserFromStorage = () => {
  return (
    LocalStorage.get(AppStorageKeys.currentUser) ||
    SessionStorage.get(AppStorageKeys.currentUser)
  );
};

export const getRedirectQueryParams = (path) => {
  const currentUser = getCurrentUserFromStore();
  const { username, partner, providerId, access_token, providerType } =
    currentUser;
  return `user=${username}&prov=${providerId}&part=${partner}&provtype=${providerType}&path=${path}&env=${
    AppEnvs.HS
  }&tok=${encodeURIComponent(access_token)}`;
};

export const listener = (history, dispatch) => {
  const logoutEventListener = (logoutEvent) => {
    if (
      logoutEvent.type == "message" &&
      logoutEvent.data == APIResponseErrorCodes.sessionExpired
    ) {
      dispatch(logout());
      history.push("/login");
    }
  };
  window.addEventListener("message", logoutEventListener);
};
